export default __webpack_public_path__ + "static/media/featimgone.6dc25dac.svg";